'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bson = require('bson');

var _collectIds2 = require('./collectIds');

var _collectIds3 = _interopRequireDefault(_collectIds2);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function queryDocs(idsMap, modelviews) {
  return Promise.all(Object.keys(idsMap).map(function (reference) {
    var model = modelviews.model(reference);
    return model.select({ _id: { $in: idsMap[reference].map(_bson.ObjectId) } }).then(function (docs) {
      var idMapping = {};
      docs.forEach(function (doc) {
        return idMapping[doc._id.toString()] = doc;
      });
      return _defineProperty({}, reference, idMapping);
    });
  })).then(function (docsMaps) {
    return docsMaps.reduce(function (merged, docsMap) {
      return _extends({}, merged, docsMap);
    }, {});
  });
}

function putDocs(docsMap, actions, data) {
  actions.forEach(function (action) {
    var path = action.path,
        reference = action.reference;

    var value = (0, _get2.default)(data, path);
    (0, _set2.default)(data, path, docsMap[reference][value.toString()]);
  });
  return data;
}

exports.default = function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(modelviews, schema, data) {
    var _collectIds, idsMap, actions, docsMap;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // deep copy data first?
            _collectIds = (0, _collectIds3.default)(schema, data), idsMap = _collectIds.idsMap, actions = _collectIds.actions;
            _context.next = 3;
            return queryDocs(idsMap, modelviews);

          case 3:
            docsMap = _context.sent;
            return _context.abrupt('return', putDocs(docsMap, actions, data));

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function populate(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  }

  return populate;
}();


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/populate/index.js
// module id = 1821
// module chunks = 0